var _rect, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7217_99492",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7217_99492)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7217_99492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98222 17.9891C7.81789 17.9891 5.65355 17.9663 3.48986 18.0001C2.57917 18.0144 1.93676 17.3261 2.00496 16.5079C2.04328 16.0462 1.97703 15.5702 2.05498 15.1183C2.25114 13.9845 3.02997 13.2683 3.95819 12.7033C5.1352 11.9871 6.43562 11.6235 7.7906 11.4189C8.90785 11.2508 10.0277 11.1975 11.1514 11.2956C13.1073 11.4663 14.9923 11.8767 16.6006 13.093C17.5217 13.7897 18.0777 14.6858 17.992 15.8943C17.9751 16.1313 17.99 16.3702 17.9894 16.6085C17.9855 17.4332 17.4372 17.9865 16.6052 17.9878C14.3979 17.9917 12.1901 17.9891 9.98287 17.9891H9.98222Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98148 10.5792C7.62812 10.5773 5.70866 8.64546 5.70996 6.27923C5.71126 3.9078 7.64306 1.99611 10.0341 2.00001C12.3836 2.0039 14.292 3.94027 14.2887 6.31559C14.2855 8.66624 12.3517 10.5812 9.98083 10.5792H9.98148Z",
    fill: "#C0C0C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7217_99492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.0c811061cdef99fbe51574b2a2d8141b.svg";
export { ForwardRef as ReactComponent };